import { SNCRulesAction } from "./actions";
import * as actions from "./actiontypes";
import { SNCRuleListModel } from "./models";

export function sncRules(state: SNCRuleListModel[] = [], action: SNCRulesAction): SNCRuleListModel[] {
    switch (action.type) {
        case actions.LOAD_SNCRULES_SUCCESS:
            const newSncRules = action.payload.filter(rule => !state.find(l => l.id === rule.id));
            return [...state, ...newSncRules].map(rule => ({ ...rule }));
        default:
            return state;
    }
}
